import React from 'react';
import { Loader2 } from 'lucide-react';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4db8a4] disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-[#1e3a5f] text-white hover:bg-[#0d2340] shadow-sm',
    secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200',
    outline: 'border border-[#1e3a5f] bg-transparent hover:bg-[#1e3a5f]/5 text-[#1e3a5f]',
    ghost: 'hover:bg-gray-100 text-gray-700 hover:text-gray-900'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 py-2 text-sm',
    lg: 'h-12 px-8 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-107">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-108" />}
      {children}
    </button>;
}